import { PropsWithChildren, useEffect } from 'react';
import { GrowthBookProvider as GBProvider, GrowthBook } from '@growthbook/growthbook-react';
import { IS_PROD } from '@fintronners/react-utils/src/envConstants';

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: !IS_PROD(),
  subscribeToChanges: true,
});

const GrowthBookProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    growthbook.init();
  }, []);

  return <GBProvider growthbook={growthbook}>{children}</GBProvider>;
};

export default GrowthBookProvider;
